import { DEVICE_TYPE } from '../constants/analytics-context.constants';
import type { TDeviceType } from '../types/analytics-context.types';

export const resolveDeviceType = (userAgent: string, maxTouchPoints: number): TDeviceType => {
  const isAndroid = /Android/.test(userAgent);
  const isTouchMac = /Macintosh/.test(userAgent) && maxTouchPoints > 1;

  if (/iPad|Tablet/.test(userAgent) || isTouchMac || (isAndroid && !/Mobile/.test(userAgent))) return DEVICE_TYPE.TABLET;
  if (/Mobi|iPhone/.test(userAgent) || isAndroid) return DEVICE_TYPE.MOBILE;

  return DEVICE_TYPE.DESKTOP;
};
